export default[
    {
        path: '/admin',
        //name: 'admin',
        component: () => import(/* webpackChunkName: "admin" */'@/views/Admin.vue'),
        meta: {
            requiresAuth: true,
            roles:['ROLE_ADMIN','ROLE_RH_ADMIN'],
        },
        children:[
            {
                path:'/',
                name:'adminMain',
                component: () => import(/* webpackChunkName: "adminMain" */'@/views/admin/AdminMenu.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_ADMIN','ROLE_RH_ADMIN'],
                },
            },
            {
                path:'documentos',
                name:'adminDocumentos',
                component: () => import(/* webpackChunkName: "adminDocumentos" */'@/views/admin/docs/AdminDocumentosMain.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_ADMIN','ROLE_RH_ADMIN'],
                },
            },
            {
                path:'personal',
                //name:'adminPersonal',
                component: () => import('@/views/admin/personal/PersonalMain.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_ADMIN','ROLE_RH_ADMIN'],
                },
                children:[
                    {
                        path:'/',
                        name:'adminPersonal',
                        component: () => import('@/views/admin/personal/PersonalList.vue'),
                        meta: {
                            requiresAuth: true,
                            roles:['ROLE_ADMIN','ROLE_RH_ADMIN'],
                        },
                    },
                    {
                        path:'roles',
                        name:'personalRoles',
                        component: () => import('@/views/admin/personal/roles/RolesPersonal.vue'),
                        meta: {
                            requiresAuth: true,
                            roles:['ROLE_ADMIN','ROLE_RH_ADMIN'],
                        },
                    },
                    {
                        path:'nuevo',
                        name:'adminPersonalNuevo',
                        component: () => import('@/views/admin/personal/PersonalNuevo.vue'),
                        meta: {
                            requiresAuth: true,
                            roles:['ROLE_ADMIN','ROLE_RH_ADMIN'],
                        },
                    },
                    {
                        path:'edita/:id',
                        name:'adminPersonalEdita',
                        component: () => import('@/views/admin/personal/PersonalNuevo.vue'),
                        meta: {
                            requiresAuth: true,
                            roles:['ROLE_ADMIN','ROLE_RH_ADMIN'],
                        },
                    },
                    {
                        path:':id',
                        name:'adminPersonalSolo',
                        component: () => import('@/views/admin/personal/PersonalDetalles.vue'),
                        meta: {
                            requiresAuth: true,
                            roles:['ROLE_ADMIN','ROLE_RH_ADMIN'],
                        },
                    },
                ]
            },


            {
                path:'perfiles',
                name:'adminPuestos',
                component: () => import(/* webpackChunkName: "adminPuestos" */'@/views/admin/puestos/PuestosList.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_ADMIN','ROLE_RH_ADMIN'],
                },
            },
            {
                path:'records',
                name:'adminRecords',
                component: () => import(/* webpackChunkName: "adminPuestos" */'@/views/admin/records/Records.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_ADMIN','ROLE_RH_ADMIN'],
                },
            },

            {
                path:'usuarios',
                name:'adminUsuarios',
                component: () => import(/* webpackChunkName: "adminUsuarios" */'@/views/admin/usuarios/UsuariosList.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_ADMIN'],
                },
            },
            {
                path:'usuarios/nuevo',
                name:'adminUsuariosNuevo',
                component: () => import(/* webpackChunkName: "adminUsuariosNuevo" */'@/components/admin/usuarios/UsuariosForm.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_ADMIN'],
                },
            },
            {
                path:'usuarios/:id',
                name:'adminUsuariosSolo',
                component: () => import(/* webpackChunkName: "adminUsuariosSolo" */'@/components/admin/usuarios/UsuariosForm.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_ADMIN'],
                },
            },
            {
                path:'ceyeJuegos',
                //name:'adminCeyeJuegos',
                component: () => import(/* webpackChunkName: "adminCeyeJuegos" */'@/views/admin/ceye/CeyeJuegos.vue'),
                meta: {
                    requiresAuth: false,
                    roles:['ROLE_ADMIN', 'ROLE_ENFERMERIA'],
                },
                children:[
                    {
                        path:'/',
                    //name:'adminCeyeJuegos',
                        component: () => import(/* webpackChunkName: "adminCeyeJuegos" */'@/components/admin/ceye/ListCeyeJuegos.vue'),
                        meta: {
                            requiresAuth: true,
                            roles:['ROLE_ADMIN', 'ROLE_ENFERMERIA'],
                        },
                    },
                ],
            },
            {
                path:'provs',
                component:()=>import(/* webpackChunkName: "listadoProvs" */'@/views/admin/provs/ListadoProvs'),
                name:'listadoProvs',
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_ADMIN'],
                },
            },
            {
                path:'ceyeInstrumental',
                //name:'adminCeyeJuegos',
                component: () => import(/* webpackChunkName: "adminCeyeJuegos" */'@/views/admin/ceye/CeyeInstrumental.vue'),
                meta: {
                    requiresAuth: false,
                    roles:['ROLE_ADMIN', 'ROLE_ENFERMERIA'],
                },
                children:[
                    {
                        path:'/',
                    //name:'adminCeyeJuegos',
                        component: () => import(/* webpackChunkName: "adminCeyeJuegos" */'@/components/admin/ceye/ListCeyeInstrumental.vue'),
                        meta: {
                            requiresAuth: true,
                            roles:['ROLE_ADMIN', 'ROLE_ENFERMERIA'],
                        },
                    },
                ],
            },
            {
                path:'cursos',
                component: () => import(/* webpackChunkName: "cursos" */'@/views/admin/cursos/CursosPrincipal.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_ADMIN','ROLE_RH_ADMIN'],
                },
            },
            {
                path:'medicamentosAdmin',
                name:'medicamentosAdmin',
                component: () => import(/* webpackChunkName: "medicamentosAdmin" */'@/views/admin/medicamentos/MedicamentosAdminMain.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_ADMIN'],
                },
            },
            {
                path:'consumos',
                name:'adminConsumos',
                component: () => import(/* webpackChunkName: "adminConsumos" */'@/views/admin/consumos/ConsumosMain.vue'),
                meta: {
                    requiresAuth: false,
                    roles:['ROLE_ADMIN', 'ROLE_ENFERMERIA'],
                },
            },
            {
                path:'catalogoconsumos',
                name:'adminConsumosCatalogo',
                component: () => import(/* webpackChunkName: "adminConsumosCatalogo" */'@/views/admin/consumos/ConsumosCatalogo.vue'),
                meta: {
                    requiresAuth: false,
                    roles:['ROLE_ADMIN', 'ROLE_ENFERMERIA'],
                },
            },

        ],
    }
]